import {Action} from '@ngrx/store';
import {DressCode} from '../../../models/dress-code';
import {BijbEvent} from '../../../models/bijb-event';

export class UpdateDressCodeAction implements Action {
  public static readonly type = 'UpdateDressCodeAction';

  constructor(public bijbEvent: BijbEvent, public dressCode: DressCode) {
  }

  public type = UpdateDressCodeAction.type;
}
